<template>
  <div v-if="!shouldHide" class="form-group mb-3">
    <label :for="'output' + outputID" :class="noPadding ? '' : 'text-label'">
      {{ outputLabel }}&nbsp;
    </label>
    <input
      type="number"
      :value="splitResult"
      disabled
      class="calc-input-width"
      :id="'output' + outputID"
    />
    <select v-if="conversionFactors" aria-label="measurement output" class="units ms-1" v-model="unit" @change="generateFinalResult">
      <option v-for="(unitOption, index) in selectOptions" :key="index" :value="unitOption">
        {{ unitOption }}
      </option>
    </select>
    <span v-if="showSplitter" class="splitter-text">
      {{ t('whenSplit') }}
      <input
        v-model.number="splitFactor"
        @input="generateFinalResult"
        type="number"
        min="1"
        class="calc-tiny-input-width"
      />
      {{ t('ways') }} ({{ t('examplePerPlantOrPerRoom') }})
    </span>
  </div>
</template>

<script>
import { ref, reactive, watch, computed } from 'vue';
import { useI18n } from 'vue-i18n';
// import newId from '../../utils/unique_key';

export default {
  name: 'GenericOutput',
  props: {
    outputLabel: {
      type: String,
      required: true,
      default: ''
    },
    conversionFactors: {
      type: Object,
      required: true
    },
    number: {
      type: Number,
      required: true,
      default: 0
    },
    showSplitter: {
      type: Boolean,
      default: false
    },
    noPadding: Boolean,
    shouldHide: Boolean
  },
  setup(props) {
    const originalNumber = ref(props.number);
    const outputNumber = ref(props.number);
    const unit = ref(Object.keys(props.conversionFactors.from)[0]);
    const splitFactor = ref(1);
    // const outputID = newId();
    const outputID = ref(Math.random().toString(36).substr(2, 9)); // Temporary solution for unique ID

    const { t } = useI18n();

    // Create a reactive object with a function
    const translations = reactive({
      t: (key) => t(key)
    })

    watch(() => props.number, (newVal) => {
      originalNumber.value = newVal;
      generateFinalResult();
    });

    const generateFinalResult = () => {
      const result = props.conversionFactors.from[unit.value](originalNumber.value) / splitFactor.value;
      outputNumber.value = result;
    };

    const splitResult = computed(() => {
      return outputNumber.value.toFixed(4); // Adjust precision as needed
    });

    const selectOptions = computed(() => {
      return Object.keys(props.conversionFactors.from);
    });

    return { t: translations.t, originalNumber, outputNumber, unit, splitFactor, outputID, generateFinalResult, splitResult, selectOptions };
  }
};
</script>
